import { Sparkles } from "lucide-react";

export function Logo({ className = "", iconSize = 22, textClass = "text-xl" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="relative flex items-center justify-center">
        <Sparkles size={iconSize} className="text-amber-300 drop-shadow-[0_0_8px_rgba(229,193,88,0.6)]" />
      </span>
      <span className={`font-serif font-semibold tracking-tight ${textClass}`}>
        <span className="text-slate-50">Myssti</span>
        <span className="gold-text">cChat</span>
      </span>
    </div>
  );
}
